import {
    MDBContainer,
    MDBTabsPane,
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBBtn,
    MDBCollapse,
    MDBCardLink,
    MDBInput,
    MDBIcon,
    MDBRow,
    MDBCol,
    MDBListGroup, MDBListGroupItem
} from 'mdb-react-ui-kit';
import React, {useEffect, useState} from 'react';
import BillsMultiSelector from './BillsMultiSelector';
import NotificationListDetails from './NotificationListDetails';
import axios from "axios";

const NotificationListBody = ({ active }) => {
    const [expandedRow, setExpandedRow] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);

    /*
        const [suggestions, setSuggestions] = useState([]);

        useEffect(() => {
            if (searchTerm.length >= 2) {
                fetchSuggestions();
            } else {
                setSuggestions([]);
            }
        }, [searchTerm]);

        const getSearchPayload = (text) => {
            setSearchTerm(text);

            // Regular expression to match bill types and numbers
            const billRegex = /^(HB|HR|HJ|SB|SR|SJ)\s*(\d+)$/i;
            const match = text.match(billRegex);

            if (match) {
                const [, billType, billNumber] = match;
                return {
                    billNumber: Number(billNumber),
                    billType: billType.toUpperCase()
                };
            }

            // If it's just a number
            if (!isNaN(text)) {
                return {
                    billNumber: Number(text)
                };
            }

            // Default case: search by draft number and short title
            return {
                draftNumber: text,
                shortTitle: text
            };
        };

        const filterValidValues = (obj) => {
            const validObj = {};
            Object.entries(obj).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== false) {
                    if (Array.isArray(value) && value.length > 0) {
                        validObj[key] = value;
                    } else if (typeof value === 'string' && value.trim() !== '') {
                        validObj[key] = value;
                    } else if (!Array.isArray(value) && typeof value !== 'string') {
                        validObj[key] = value;
                    }
                }
            });
            return validObj;
        }

        const buildSearchPayload = () => {
            return filterValidValues({
                sessionIds: [2],
                optionalFields: searchTerm ? getSearchPayload(searchTerm) : false
            });
        };

        const extractBillNumbers = (data) => {
            if (data && data.content && Array.isArray(data.content)) {
                return data.content.map(item => ({
                    billNumber: item.billNumber,
                    billType: item.billType.code
                })).filter(info => info.billNumber !== undefined);
            }
            return []; // Return an empty array if the data structure is not as expected
        };

        const fetchSuggestions = async () => {
            try {
                const url = `${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/bills/search?includeCounts=true&sort=draft.draftNumber,asc&limit=100&offset=0`;
                const payload = buildSearchPayload();
                const response = await axios.post(url, payload);
                const billNumbers = extractBillNumbers(response.data);
                setSuggestions(billNumbers);
            } catch (error) {
                console.error('Error fetching suggestions:', error);
                setSuggestions([]); // Set to empty array in case of error
            }
        };
        const handleSuggestionClick = (billNumber) => {
            setSearchTerm(billNumber.toString());
            setSuggestions([]);
        };
    */

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };


    const toggleRow = (rowId) => {
        setExpandedRow(expandedRow === rowId ? null : rowId);
    };

    const rows = [
        { id: 1, listName: <MDBInput label="Bill 101" id="form1" type="text" />, billsMultiSelector: <BillsMultiSelector />, action: <MDBIcon className='notitification-list-delete-btn' fas icon="trash" />, expandBody: <NotificationListDetails /> }
    ];

    return (
        <MDBTabsPane show={active}>
            <MDBContainer fluid>
                <div>
                    <MDBRow className="ms-auto" style={{ maxWidth: '400px' }}>
                        <MDBCol className='p-0'>
                            <MDBInput
                                label="Search"
                                id="billSearchNotice"
                                type="text"
                                value={searchTerm}
                                onChange={handleInputChange}
                            />
                            {suggestions.map((bill) => (
                                <MDBListGroupItem
                                    key={bill.billNumber}
                                    tag="button"
                                    action
                                    onClick={() => handleSuggestionClick(bill.billNumber)}
                                >
                                    <div>{bill.billType} {bill.billNumber}</div>
                                </MDBListGroupItem>
                            ))}
                        </MDBCol>
                        <MDBCol>
                            <MDBBtn color="primary"><MDBIcon fas icon="plus" /> Add List</MDBBtn>
                        </MDBCol>
                    </MDBRow>
                </div>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Bills</th>
                            <th></th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        {rows.map((row) => (
                            <React.Fragment key={row.id}>
                                <tr>
                                    <td style={{ width: "max-content" }}>
                                        <MDBCardLink size='sm' color='link' onClick={() => toggleRow(row.id)}>
                                            {expandedRow === row.id ? <i className="fas fa-angle-up"></i> : <i className="fas fa-angle-down"></i>}
                                        </MDBCardLink>
                                    </td>
                                    <td>{row.listName}</td>
                                    <td>{row.billsMultiSelector}</td>
                                    <td>{row.action}</td>
                                </tr>
                                <tr>
                                    <td colSpan="4" style={{ padding: 0 }}>
                                        <MDBCollapse show={expandedRow === row.id}>
                                            <div className="p-3 bg-light">
                                                <h5>{row.name}</h5>
                                                <div>{row.expandBody}</div>
                                            </div>
                                        </MDBCollapse>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </MDBTableBody>
                </MDBTable>
            </MDBContainer>
        </MDBTabsPane>
    );
}

export default NotificationListBody;